/**
 * Utility functions for section creation
 */
import { PLENUM_LENGTH } from '../data/bot';
import { IBotSection } from '../../models';

/**
 * Calculates extra length needed for fan clearance
 */
export function calculateExtraLengthForFan(
  botSection: IBotSection,
  nextSection: IBotSection | null,
  dbOrderRate: number,
  thickness: number | null,
): number {
  const tunnelFan = nextSection?.component;
  if (nextSection?.type === 'fan' && tunnelFan) {
    const min_length = tunnelFan.min_clear_ups + (dbOrderRate ? 0 : thickness || 0);
    if (botSection.type === 'plenum' && min_length > PLENUM_LENGTH) {
      return min_length - PLENUM_LENGTH;
    } else if (botSection.type === 'coil' && botSection.duty_id === 1) {
      return min_length;
    }
  }
  return 0;
}

/**
 * Calculates length adjustments for a section
 */
export function calculateLengthAdjustments(
  orderRate: number,
  validSectionsLength: number,
  botSection: IBotSection,
  length: number,
  sizerSettings: any,
  thickness: number | null,
): number {
  let adjustedLength = length;
  if (orderRate === 1 && botSection.type !== 'plenum' && length) {
    adjustedLength += sizerSettings?.thickness || thickness || 0;
  }
  if (
    orderRate === validSectionsLength &&
    botSection.type !== 'plenum' &&
    length
  ) {
    adjustedLength += sizerSettings?.thickness || thickness || 0;
  }
  if (
    orderRate === validSectionsLength &&
    (botSection.type === 'filter' ||
      (botSection.type === 'coil' && botSection.duty_id === 2))
  ) {
    adjustedLength += 6;
  }

  return adjustedLength;
}
